import { createMarkup } from "../../../utils/helperServices";
import { CustomContainer, Row, Col } from "../../atoms/DependencyHelper";
import styles from "./UpgradeBenifits.module.scss"
const UpgradeBenifits = (props) => {
    
  return (
    <CustomContainer className={styles["upgrade-benifits"]}>
      <Row className={`${styles["upgrade-benifits__row"]} m-0`}>
          {props.simpleCardData.cards.map((item)=>(
        <Col  className={styles["upgrade-benifits__row__col"]}>
            <CustomContainer>
               <img src= {item.image} className={styles["upgrade-benifits__row__col__img"]}/>
            </CustomContainer>
            <CustomContainer className={styles["card-title"]}>
                {item.title}
            </CustomContainer>
            <CustomContainer  className={styles["card-description"]} dangerouslySetInnerHTML={createMarkup(item.description)}></CustomContainer>

        </Col>
          ))}
      </Row>
    </CustomContainer>
  );
};

export default UpgradeBenifits;
